import { DynamicContentType, Shadow } from '../../types/content.types.js'
import { Rounded } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type ImageCollageData = {
  marginBottom?: string
  marginTop?: string
  mainImage?: FileEntryBM
  secondaryImage?: FileEntryBM
  layout: 'bottomLeft' | 'bottomRight'
  rounded?: Rounded
  shadow?: Shadow
}

export const imageCollage: DynamicContentType<ImageCollageData> = {
  name: 'imageCollage',
  viewName: 'Bildkollage',
  featureKey: 'imageCollage',
  icon: LucideIconName.ImagePlus,
  uuid: '',
  data: {
    layout: 'bottomRight',
  },
}
